export default __webpack_public_path__ + "static/media/edit_lead.f682ec04.svg";